var _circle, _circle2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRiderAltIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.16675,
    cy: 13.3333,
    r: 2.5,
    stroke: "white",
    strokeOpacity: 0.65,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.8333,
    cy: 13.3333,
    r: 2.5,
    stroke: "white",
    strokeOpacity: 0.65,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 11.1667C5.97386 11.1667 5.75 11.3905 5.75 11.6667C5.75 11.9428 5.97386 12.1667 6.25 12.1667V11.1667ZM10.4167 11.6667V12.1667C10.5493 12.1667 10.6765 12.114 10.7702 12.0202L10.4167 11.6667ZM13.75 8.33333L14.1036 8.68689C14.2466 8.54389 14.2893 8.32883 14.2119 8.14199C14.1345 7.95515 13.9522 7.83333 13.75 7.83333V8.33333ZM5 7.83333C4.72386 7.83333 4.5 8.05719 4.5 8.33333C4.5 8.60947 4.72386 8.83333 5 8.83333V7.83333ZM5.89645 11.3131C5.70118 11.5084 5.70118 11.825 5.89645 12.0202C6.09171 12.2155 6.40829 12.2155 6.60355 12.0202L5.89645 11.3131ZM9.93689 8.68689C10.1321 8.49162 10.1321 8.17504 9.93689 7.97978C9.74162 7.78452 9.42504 7.78452 9.22978 7.97978L9.93689 8.68689ZM6.25 12.1667H10.4167V11.1667H6.25V12.1667ZM10.7702 12.0202L14.1036 8.68689L13.3964 7.97978L10.0631 11.3131L10.7702 12.0202ZM13.75 7.83333H5V8.83333H13.75V7.83333ZM6.60355 12.0202L9.93689 8.68689L9.22978 7.97978L5.89645 11.3131L6.60355 12.0202Z",
    fill: "white",
    fillOpacity: 0.65
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 5H12.4999L13.7499 7.5L15.4166 10.8333",
    stroke: "white",
    strokeOpacity: 0.65,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiderAltIcon);
export default __webpack_public_path__ + "static/media/rider-alt-icon.3aff8d46.svg";
export { ForwardRef as ReactComponent };